import angular from "angular"
import uiRouter from "angular-ui-router"
import routing from "./markerspanel.routes"

export default angular.module("makeamapAngularApp.markerspanel", [uiRouter]).config(routing).name
